<template>
    <div class="card mb-5 mb-xxl-8">
        <div class="card-header flex-wrap border-0 pt-6 pb-0 mb-5">
            <div class="card-title">
                <h3 class="card-label">{{ $t('shop.order_detail') }}</h3>
            </div>
            <div class="card-toolbar" v-if="!shop?.archive">
                <button class="btn btn-sm btn-secondary me-2" @click="openInvoiceModal()">{{ $t('shop.see_order_detail')
                    }}</button>
                <button v-if="canPaidOutstanding && can('credit_payment')" class="btn btn-sm btn-primary" @click="paidOutstandingModal()">{{ $t('shop.paid_outstanding') }}</button>
            </div>
        </div>

        <div v-show="isReady" class="card-body">
            <div class="row">
                <div class="table-responsive">
                    <table id="kt_datatable_both_scrolls" class="table table-striped table-row-bordered gy-5 gs-7">
                        <thead>
                            <tr class="fw-semibold fs-6 text-gray-800 text-uppercase gs-0">
                                <th class="min-w-150px">{{ $t('shop.shop_invoice.number') }}</th>
                                <th class="min-w-150px">{{ $t('shop.shop_invoice.amount') }}</th>
                                <th class="min-w-200px">{{ $t('shop.shop_invoice.payment_method') }}</th>
                                <th class="min-w-100px">{{ $t('shop.shop_invoice.payment_date') }}</th>
                                <th class="min-w-100px">{{ $t('shop.shop_invoice.action') }}</th>
                            </tr>
                        </thead>
                        <tbody v-if="checkoutDetails && (checkoutDetails?.invoices?.length > 0)">
                            <tr v-for="(item, key) in checkoutDetails?.invoices" :key="item.id">
                                <td>{{ checkoutDetails?.checkout_data?.reference + '-' + key }} </td>
                                <td>{{ $formatLocalAmount(item?.amount) }} {{ currency }}</td>
                                <td>{{ paymentModeLabel(item?.payment_method) }}</td>
                                <td>{{ item?.payment_date ?? '---' }}</td>
                                <td>
                                    <a href="javascript:;" class="btn btn-sm btn-clean btn-icon"
                                        @click="openInvoiceModal(item, key)">
                                        <i class="fa fa-eye fs-2"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr class="text-center">
                                <td colspan="5"><strong>{{ $t('shop.shop_invoice.no_data') }}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-show="!isReady" class="card-body loader">
            <Loader text="Loading..." />
        </div>

        <div class="modal fade" tabindex="-1" id="orderDetailModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t("shop.invoice") }}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                            aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                        transform="rotate(-45 6 17.3137)" fill="currentColor" />
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                        transform="rotate(45 7.41422 6)" fill="currentColor" />
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="card-body py-5">
                            <div class="mw-lg-950px mx-auto w-100">
                                <div class="d-flex justify-content-between flex-column flex-sm-row mb-9">
                                    <h4 class="fw-boldest text-gray-800 fs-2qx pe-5 pb-7">{{ $t("shop.invoice") }}</h4>
                                    <div class="text-sm-end">
                                        <div class="text-sm-end fw-bold fs-4 text-muted ">
                                            <div class="fw-boldest text-gray-800"> {{ checkoutDetails?.checkout_data?.shop_data.name }}</div>
                                            <div>{{ checkoutDetails?.checkout_data?.shop_data.pĥone }}</div>
                                            <div>{{ checkoutDetails?.checkout_data?.shop_data.address }} </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pb-12">
                                    <div class="d-flex flex-column gap-7 gap-md-10">
                                        <div class="separator"></div>
                                        <div class="d-flex flex-column flex-sm-row gap-7 gap-md-10 fw-bolder">
                                            <div class="flex-root d-flex flex-column">
                                                <span class="text-muted">{{ $t('contacts.order_number') }}</span>
                                                <span v-if="!acoumpteDetail.isGeneral" class="fs-5">{{ checkoutDetails?.checkout_data?.reference + '-' + acoumpteDetail.key }}</span>
                                                <span v-else class="fs-5">{{ checkoutDetails?.checkout_data?.reference
                                                    }}</span>
                                            </div>
                                            <div class="flex-root d-flex flex-column">
                                                <span class="text-muted">Date</span>
                                                <span class="fs-5">{{ checkoutDetails?.checkout_data?.date }}</span>
                                            </div>
                                            <div class="flex-root d-flex flex-column"
                                                v-show="checkoutDetails?.checkout_data?.customer_name">
                                                <span class="text-muted">{{ $t('customer') }}</span>
                                                <span class="fs-5">{{ checkoutDetails?.checkout_data?.customer_name
                                                    }}</span>
                                            </div>
                                        </div>

                                        <div class="d-flex justify-content-between flex-column">
                                            <div class="table-responsive border-bottom mb-9">
                                                <table class="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                                    <thead>
                                                        <tr class="border-bottom fs-6 fw-bolder text-muted">
                                                            <th class="min-w-175px pb-2">{{ $t('shop.products') }}</th>
                                                            <th class="min-w-70px text-end pb-2">{{ $t('shop.unit_price') }}</th>
                                                            <th class="min-w-80px text-end pb-2">{{ $t('shop.quantity')
                                                                }}</th>
                                                            <th class="min-w-100px text-end pb-2">{{ $t('shop.total') }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="fw-bold text-gray-600">
                                                        <tr v-for="product in checkoutDetails.products_with_quantity"
                                                            :key="product.id">
                                                            <td>
                                                                <div class="d-flex align-items-center">
                                                                    <div class="ms-5">
                                                                        <div class="fw-bolder"> {{ product.name }}
                                                                            <span v-if="product.bundle_title" class="badge badge-light-primary ms-1"><i class="bi bi-box-seam me-1"></i>{{ product.bundle_title }}</span>
                                                                            <br />
                                                                            <span v-if="product.discount != 0"
                                                                                style=" font-size:10px; margin-left: 5px!important">
                                                                                ({{ $t('remise') }} {{ product.discount
                                                                                }} %)</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td class="text-end"> {{ $formatLocalAmount(product.price)
                                                                }} {{ currency }}</td>
                                                            <td class="text-end">{{ product.quantity }}</td>
                                                            <td class="text-end"> {{ $formatLocalAmount(product.quantity_price) }} {{ currency }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3" class="text-end">{{ $t('shop.subtotal') }}
                                                            </td>
                                                            <td class="text-end">{{ $formatLocalAmount(checkoutDetails?.checkout_data?.sub_total) }}
                                                                {{ currency }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3" class="text-end">{{ $t('shop.reduction') }}
                                                            </td>
                                                            <td class="text-end">
                                                                {{ $formatLocalAmount(checkoutDetails?.checkout_data?.reduction) }}  {{ currency }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3" class="text-end">{{ $t('shop.total_amount_to_pay') }} </td>
                                                            <td class="text-end"> {{ $formatLocalAmount(checkoutDetails?.checkout_data?.amountTotal) }}
                                                                {{ currency }}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="acoumpteDetail.isGeneral">
                                                            <td colspan="3" class="text-end">{{ $t('shop.total_amount_payed') }} </td>
                                                            <td class="text-end">
                                                                {{ $formatLocalAmount(checkoutDetails?.checkout_data?.amountDonated) }} {{ currency }}
                                                            </td>
                                                        </tr>
                                                        <tr v-else class="border-top border-bottom">
                                                            <td colspan="3" class="text-end">{{ $t('shop.total_amount_payed') }} </td>
                                                            <td class="text-end">
                                                                {{ $formatLocalAmount(acoumpteDetail?.total_amount_payed) }} {{ currency }}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="!acoumpteDetail.isGeneral">
                                                            <td colspan="3" class="fs-3 text-dark fw-bolder text-end">{{
                                                                $t('shop.amount_rest') }}
                                                            </td>
                                                            <td class="text-dark fs-3 fw-boldest text-end"> {{
                                                                $formatLocalAmount(acoumpteDetail?.rest_amount) }}
                                                                {{ currency }}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="!acoumpteDetail.isGeneral">
                                                            <td colspan="3" class="fs-2 text-dark fw-bolder text-end">{{
                                                                $t('shop.amount_payed') }}
                                                            </td>
                                                            <td class="text-dark fs-2 fw-boldest text-end"> {{
                                                                $formatLocalAmount(acoumpteDetail?.amount) }} {{
                                                                currency }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button v-show="false" type="button" class="btn btn-sm btn-light"
                                        data-bs-dismiss="modal">{{$t('button.close') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" tabindex="-1" id="paidOutstandingModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t("shop.paid_outstanding_form") }}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                            aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                        transform="rotate(-45 6 17.3137)" fill="currentColor" />
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                        transform="rotate(45 7.41422 6)" fill="currentColor" />
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="card-body py-5">
                            <div class="d-flex flex-column gap-7 gap-md-10">
                                <div class="d-flex flex-column flex-sm-row gap-7 gap-md-10 fw-bolder">
                                    <div
                                        class="alert alert-primary d-flex align-items-center flex-root d-flex flex-column">
                                        <i class="ki-duotone ki-shield-tick fs-2hx text-success me-4"><span
                                                class="path1"></span><span class="path2"></span></i>
                                        <div class="d-flex flex-column">
                                            <h4 class="mb-1 text-dark">{{
                                                $formatLocalAmount(checkoutDetails?.checkout_data?.amountTotal) }} {{
                                                currency}}</h4>
                                            <span class="text-muted">{{ $t('shop.total_amount_to_pay') }}</span>
                                        </div>
                                    </div>
                                    <div
                                        class="alert alert-warning d-flex align-items-center flex-root d-flex flex-column">
                                        <i class="ki-duotone ki-shield-tick fs-2hx text-success me-4"><span
                                                class="path1"></span><span class="path2"></span></i>
                                        <div class="d-flex flex-column">
                                            <h4 class="mb-1 text-dark">{{
                                                $formatLocalAmount(checkoutDetails?.checkout_data?.amountDonated) }}
                                                {{currency }}</h4>
                                            <span class="text-muted">{{ $t('shop.total_amount_payed') }}</span>
                                        </div>
                                    </div>
                                    <div
                                        class="alert alert-danger d-flex align-items-center flex-root d-flex flex-column">
                                        <i class="ki-duotone ki-shield-tick fs-2hx text-success me-4"><span
                                                class="path1"></span><span class="path2"></span></i>
                                        <div class="d-flex flex-column">
                                            <h4 class="mb-1 text-dark">{{
                                                $formatLocalAmount(checkoutDetails?.checkout_data?.amountTotal-checkoutDetails?.checkout_data?.amountDonated)}}
                                                {{ currency }}</h4>
                                            <span class="text-muted">{{ $t('shop.amount_rest') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="separator"></div>
                            <h4 class="mt-4">
                                {{ $t('shop.payment') }}
                            </h4>
                            <form class="row mt-4" @submit.prevent="submitPaidOutstanding">
                              <Select2
                                  parent-id="#paidOutstandingModal"
                                  containerClass="col-md-6 mt-4"
                                  name="paidMethod"
                                  :multiple="false"
                                  :label="$t('shop.paid_payment_method')"
                                  labelClass="text-black"
                                  selectClass="form-select"
                                  :isRequired="true"
                                  :showSearch="false"
                                  :placeholderText="$t('shop.paid_payment_method')"
                                  v-model="paidOutstandingData.payments[0].mode">
                                <option value="liquidity">{{ $t('payment.cash') }}</option>
                                <option value="MOBILE">Mobile Money</option>
                                <option value="MOMO_PAY">MoMo Pay</option>
                              </Select2>
                              <Select2
                                  parent-id="#paidOutstandingModal"
                                  containerClass="col-md-6 mt-4"
                                  name="paidType"
                                  :multiple="false"
                                  :label="$t('shop.paid_type')"
                                  labelClass="text-black"
                                  selectClass="form-select"
                                  :isRequired="true"
                                  :showSearch="false"
                                  :placeholderText="$t('shop.paid_type')"
                                  v-model="paidOutstandingData.type">
                                <option value="amount">{{ $t('shop.shop_invoice.amount') }}</option>
                                <option value="percent">{{ $t('shop.shop_invoice.percent') }}</option>
                              </Select2>

                                <div class="col-12 mt-4">
                                    <label class="required">
                                      {{ $t('shop.amount_percent') }}
                                    </label>
                                    <div class="input-group">
                                      <VueNumberFormat
                                          class="form-control"
                                          required
                                          :max="checkoutDetails?.checkout_data?.amountTotal-checkoutDetails?.checkout_data?.amountDonated"
                                          :placeholder="$t('shop.amount_percent')"
                                          :aria-label="$t('shop.amount_percent')" aria-describedby="basic-addon2"
                                          v-model:value="paidOutstandingData.payments[0].amount"
                                          :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }">
                                      </VueNumberFormat>
                                      <span class="input-group-text" id="basic-addon2">
                                          <span v-if="paidOutstandingData.type == 'amount'">{{ currency}}</span>
                                          <span v-else>%</span>
                                      </span>
<!--                                      :max="checkoutDetails?.checkout_data?.amountTotal-checkoutDetails?.checkout_data?.amountDonated"-->
<!--                                        <input type="number" class="form-control" required-->
<!--                                               v-model="paidOutstandingData.payments[0].amount"-->
<!--                                            :placeholder="$t('shop.amount_percent')"-->
<!--                                            :aria-label="$t('shop.amount_percent')" aria-describedby="basic-addon2" />-->
<!--                                        <span class="input-group-text" id="basic-addon2">-->
<!--                                            <span v-if="paidOutstandingData.type == 'amount'">{{ currency}}</span>-->
<!--                                            <span v-else>%</span>-->
<!--                                        </span>-->
                                    </div>
                                  <span class="text-danger text-muted" v-if="!canPaid">
                                        {{ $t('feedback.max') }}{{ $formatLocalAmount(checkoutDetails?.checkout_data?.amountTotal-checkoutDetails?.checkout_data?.amountDonated)}}
                                        {{ currency }}
                                  </span>
                                </div>
                                <div class="col-12 mt-4">
                                    <label class="">Notes</label>
                                    <div class="form-floating">
                                        <textarea class="form-control" placeholder="Note..." style="height: 100px"
                                            v-model="paidOutstandingData.note"></textarea>
                                        <label for="floatingTextarea2">Notes</label>
                                    </div>
                                </div>
                                <div class="col-12 mt-4 text-end">
                                    <button type="submit" :disabled="isStart || !canPaid" class="btn btn-primary">{{ $t("shop.shop_invoice.paid") }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" tabindex="-1" id="kt_modal_1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ acoumpteDetail?.rest_amount == 0 ? $t('session.invoice') :  $t('session.invoice_accompte') }}</h5>
            
                        <button :disabled="isLoading" class="btn btn-sm btn-primary me-2" @click.prevent="printButton">{{ $t('session.print') }}</button>
                        <button :disabled="isLoading" v-show="!symefResponse" @click.prevent="generateSymefInvoice"
                            class="btn btn-sm btn-info">{{ $t('session.normalise') }}</button>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                        <span class="svg-icon svg-icon-2x">x</span>
                        </div>
                    </div>
            
                    <div class="modal-body">
                        <div class="modal-body">
                            <div id="invoice-content" class="m-0">
                                <div id="invoice" class="receipt-ticket mx-auto">
                                    <table class="receipt-header-table">
                                        <tbody>
                                        <tr>
                                            <td colspan="2" class="text-center">
                                                <strong class="company-name">{{ checkoutDetails?.checkout_data?.shop_data?.name }}</strong>
                                            </td>
                                        </tr>
                                        <tr v-if="checkoutDetails?.checkout_data?.shop_data?.address || checkoutDetails?.checkout_data?.shop_data?.phone">
                                            <td colspan="2" class="text-center header-line">
                                                <template v-if="checkoutDetails?.checkout_data?.shop_data?.address">{{ checkoutDetails?.checkout_data?.shop_data?.address }}</template>
                                                <template v-if="checkoutDetails?.checkout_data?.shop_data?.address && checkoutDetails?.checkout_data?.shop_data?.phone"> · </template>
                                                <template v-if="checkoutDetails?.checkout_data?.shop_data?.phone">{{ $t('session.tel') }}: {{ checkoutDetails?.checkout_data?.shop_data?.phone }}</template>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="text-center separator">- - - - - - - - - - - - - - -</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="text-center header-line">{{ acoumpteDetail?.rest_amount == 0 ? $t('session.invoice') : $t('session.invoice_accompte') }} · {{ checkoutDetails?.checkout_data?.date }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="text-center header-line">{{ $t('session.cashier') }}: {{ checkoutDetails?.checkout_data?.seller?.fullname }} · {{ $t('session.num_ticket') }}: {{ acoumpteDetail.isGeneral ? checkoutDetails?.checkout_data?.reference : checkoutDetails?.checkout_data?.reference + '-' + acoumpteDetail.key }}</td>
                                        </tr>
                                        <tr v-if="checkoutDetails?.checkout_data?.customer_name">
                                            <td colspan="2" class="text-center header-line">Client: {{ checkoutDetails?.checkout_data?.customer_name }}</td>
                                        </tr>
                                        </tbody>
                                    </table>

                                    <table class="receipt-products-table">
                                        <tbody>
                                        <tr>
                                            <td colspan="2" class="separator">- - - - - - - - - - - - - - -</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2"><strong>{{ $t('products') || 'Produits' }}</strong></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="separator-light"></td>
                                        </tr>
                                        <template v-for="product in checkoutDetails.products_with_quantity" :key="product.name">
                                            <tr class="product-row">
                                                <td class="product-name-cell">
                                                    {{ product.name }}
                                                    <span v-if="product.discount != 0" class="discount-text">
                                                        <br/>({{ $t('remise') }} {{ product.discount }}%)
                                                    </span>
                                                    <span v-if="product.bundle_title" class="discount-text">
                                                        <br/>({{ product.bundle_title }})
                                                    </span>
                                                </td>
                                                <td class="product-price-cell">
                                                    {{ product.quantity }} x {{ $formatLocalAmount(product.price) }} {{ currency ? currency : '' }}
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>

                                    <table class="receipt-totals-table">
                                        <tbody>
                                        <tr>
                                            <td colspan="2" class="separator">- - - - - - - - - - - - - - -</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('sub_total') }}</td>
                                            <td class="text-right">{{ $formatLocalAmount(checkoutDetails?.checkout_data?.sub_total) }} {{ currency ? currency : '' }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('reduction') }}</td>
                                            <td class="text-right">{{ $formatLocalAmount(checkoutDetails?.checkout_data?.reduction) }} {{ currency ? currency : '' }}</td>
                                        </tr>
                                        <tr class="payment-row">
                                            <td>{{ $t('session.method_cash') }}</td>
                                            <td class="text-right">{{ $formatLocalAmount(acoumpteDetail.isGeneral ? checkoutDetails?.checkout_data?.amountDonated : acoumpteDetail?.total_amount_payed) }} {{ currency ? currency : '' }}</td>
                                        </tr>
                                        <tr v-if="checkoutDetails?.checkout_data?.status === 'PAID' && acoumpteDetail?.rest_amount == 0">
                                            <td>{{ $t('remise_cash') }}</td>
                                            <td class="text-right">{{ $formatLocalAmount(checkoutDetails?.checkout_data?.cash_change) }} {{ currency ? currency : '' }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="separator">= = = = = = = = = = = = = = =</td>
                                        </tr>
                                        <tr class="total-final-row">
                                            <td><strong>{{ $t('session.total') }}</strong></td>
                                            <td class="text-right"><strong>{{ $formatLocalAmount(checkoutDetails?.checkout_data?.amountTotal) }} {{ currency ? currency : '' }}</strong></td>
                                        </tr>

                                        <template v-if="acoumpteDetail?.rest_amount > 0">
                                            <tr>
                                                <td colspan="2" class="separator">- - - - - - - - - - - - - - -</td>
                                            </tr>
                                            <tr>
                                                <td>{{ $t('cart.acompte_total') }}</td>
                                                <td class="text-right">{{ $formatLocalAmount(checkoutDetails?.checkout_data?.amountTotal) }} {{ currency ? currency : '' }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ $t('cart.acompte_title') }}</td>
                                                <td class="text-right">{{ $formatLocalAmount(acoumpteDetail?.total_amount_payed) }} {{ currency ? currency : '' }}</td>
                                            </tr>
                                            <tr class="remaining-row">
                                                <td>{{ $t('cart.remaining') }}</td>
                                                <td class="text-right">{{ $formatLocalAmount(acoumpteDetail?.rest_amount) }} {{ currency ? currency : '' }}</td>
                                            </tr>
                                        </template>

                                        <template v-if="checkoutDetails?.checkout_data?.note">
                                            <tr>
                                                <td colspan="2" class="separator">- - - - - - - - - - - - - - -</td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">{{ $t('cart.note') }}: {{ checkoutDetails.checkout_data.note }}</td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>

                                    <div v-if="symefResponse && symefResponse.qrCode" class="qr-section">
                                        <table class="qr-table">
                                            <tbody>
                                            <tr>
                                                <td>{{ $t('session.code_dgi') }}</td>
                                                <td>{{ symefResponse.codeMECeFDGI }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ $t('session.code_nim') }}</td>
                                                <td>{{ symefResponse.nim }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ $t('session.code_compteur') }}</td>
                                                <td>{{ symefResponse.counters }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ $t('session.mecef_heure') }}</td>
                                                <td>{{ symefResponse.dateTime }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <div class="qr-code">
                                            <QRCodeVue3
                                                :width="100"
                                                :height="100"
                                                :value="symefResponse.qrCode"
                                                :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                                                :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                                                :dotsOptions="{type: 'square', gradient: {type: 'linear', rotation: 0, colorStops: [{ offset: 0, color: 'black' }]}}"
                                            />
                                        </div>
                                    </div>

                                    <div class="receipt-footer">
                                        <p class="separator">- - - - - - - - - - - - - - -</p>
                                        <p class="thanks-text">{{ $t('session.thanks') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router"
import { useStore } from "vuex";
import { useHasAbility } from "@/composables/hasAbility";
import { paymentModeLabel } from '@/helpers/paymentMode'
import QRCodeVue3 from "qrcode-vue3";
import Select2 from "@/components/Select2.vue";
import VueNumberFormat from 'vue-number-format'
import Loader from "@/components/Loader.vue";

const router = useRouter()
const route = useRoute()
const store = useStore()
const { can } = useHasAbility()

const currency = ref(null)

const locale = computed(() => i18n.global.locale)
const isReady = ref(false)
const isStart = ref(false)
const isLoading = ref(false)
const isNormalized = ref(false)
const checkout_id = ref(null)
const symefResponse = ref({})

const acoumpteDetail = ref({
    isGeneral: true,
    amount: 0,
    total_amount_payed: 0,
    rest_amount: 0,
    key: 0
})

const paidOutstandingData = ref({
    pos_checkout_id: route.params.detail_id,
    type: 'amount',
    payments: [{
        amount: 0,
        mode: "liquidity"
    }],
    note: ""
})

const canPaidOutstanding = ref(false)

const checkoutDetails = computed(() => store.getters['shop/getPosCheckoutDetails'])
const canPaid = computed(() => {
  if(paidOutstandingData.value?.type == 'percent') {
    return paidOutstandingData.value.payments[0].amount <= 100;
  }
  const rest = checkoutDetails.value?.checkout_data?.amountTotal - checkoutDetails.value?.checkout_data?.amountDonated
  return paidOutstandingData.value.payments[0].amount <= rest;
})

watch(() => checkoutDetails.value, (newValue) => {
    if (newValue) {
        let rest = newValue?.checkout_data?.amountTotal - newValue?.checkout_data?.amountDonated
        if(rest > 0) {
            canPaidOutstanding.value = true
        } else {
            canPaidOutstanding.value = false
        }
    }
})

async function verifySymefInvoice(){
    isLoading.value = true
    isNormalized.value = false
    await store.dispatch('session/verifyInvoiceNormalization', checkout_id.value).then((res) => {
        symefResponse.value = res.data
        if (symefResponse.value) {
            isNormalized.value = true
        }
    })
    
    isLoading.value = false
}

async function generateSymefInvoice(){
    isLoading.value = true
    try {
        await store.dispatch('session/normalizationInvoice', checkout_id.value).then((res) => {
            symefResponse.value = res.data
            window.toastr['success'](i18n.global.t('shop.success_invoice'))
        })
    } catch (e) {
    }
    isLoading.value = false
}

function openInvoiceModal(item = null, key = null) {
    checkout_id.value = checkoutDetails.value?.checkout_data?.id
    verifySymefInvoice()
    if (item) {
        Promise.all([
            acoumpteDetail.value.isGeneral = false,
            acoumpteDetail.value.total_amount_payed = item.total_amount_payed,
            acoumpteDetail.value.amount = item.amount,
            acoumpteDetail.value.rest_amount = item.rest_amount,
            acoumpteDetail.value.key = key
        ]).then(() => {
            $('#kt_modal_1').modal('toggle')
        })
    } else {
        Promise.all([
            acoumpteDetail.value.isGeneral = true
        ]).then(() => {
            $('#kt_modal_1').modal('toggle')
        })
    }
}

const submitPaidOutstanding = async () => {
    isStart.value = true
    await store.dispatch('shop/paidOutstanding', { ...paidOutstandingData.value, shop_id: route.params.id })
        .then(res => {
            paidOutstandingData.value = {
                pos_checkout_id: route.params.detail_id,
                type: 'amount',
                payments: [{
                    amount: 0,
                    mode: "liquidity"
                }],
                note: ""
            }
            isStart.value = false
            loadData()
            $('#paidOutstandingModal').modal('toggle')
            window.toastr['success'](i18n.global.t('shop.shop_invoice.paid_success'))
        })
        .catch(err => {
            isStart.value = false
            window.toastr['error'](err?.response?.data?.message || i18n.global.t('shop.shop_invoice.paid_error'))
        })
}

function paidOutstandingModal() {
    $('#paidOutstandingModal').modal('toggle')
}

onMounted(() => {
    isReady.value = false
    Promise.all([
        loadData()
    ])
        .then(res => isReady.value = true)
        .catch(err => isReady.value = true)
    isReady.value = true
})

async function loadData() {
    if (route.params.id) {
        await store.dispatch('shop/checkoutPosDetails', route.params.detail_id)
        getShopCurrency()
    }
}

async function getShopCurrency() {
    let response = await store.dispatch('shop/getCurrency')
    currency.value = response.data.currency_symbol ? response.data.currency_symbol : response.data.symbol_native
}

function printButton() {
    let prtHtml = document.getElementById('invoice-content');
    let WinPrint = window.open('', 'Print-Window', 'left=0,top=0,width=800,height=900,toolbar=1,scrollbars=0,status=0');
    WinPrint.document.write(`<!DOCTYPE html>
            <html>
            <head>
                <link href="https://fonts.googleapis.com/css?family=Inconsolata&display=swap" rel="stylesheet" type="text/css">
                    <style>
                    body{
                        margin: 0 !important;
                        font-family: 'Inconsolata', monospace;
                    }

                    @media print {
                        body{
                        margin: 0 !important;
                        font-family: 'Inconsolata', monospace;
                        }


                        #invoice, #invoice * {
                        visibility: visible;
                        }

                        #invoice {
                        margin: 0 auto !important;
                        font-family: "Inconsolata",serif;
                        }

                        .receipt-ticket {
                        text-align: left;
                        background-color: white;
                        font-size: 12px;
                        padding: 15px !important;
                        font-family: "Inconsolata",serif;
                        border: solid 1px rgb(220,220,220);
                        border-radius: 3px;
                        font-weight: bold !important;
                        max-width: 350px;
                        }

                        .receipt-ticket table {
                            width: 100%;
                            table-layout: fixed;
                            border-collapse: collapse;
                        }

                        .receipt-ticket td {
                            overflow-wrap: break-word;
                        }

                        .text-center { text-align: center; }
                        .text-right { text-align: right; }
                        .separator { text-align: center; }



                    }

                </style>
            </head>
            <body>
                ${prtHtml.innerHTML}
            </body>
            </html>`);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
}

</script>

<style scoped>
.light-danger {
    color: #f1416c;
    border-color: #fff5f8;
    background-color: #fff5f8;
    font-size: .925rem;
    border-radius: 0.325rem;
    padding: 5px 10px;
}

.light-primary {
    color: #0b3d87;
    border-color: #f1faff;
    background-color: #f1faff;
    font-size: .925rem;
    border-radius: 0.325rem;
    padding: 5px 10px;
}

@keyframes typing {
    from {
        width: 0;
    }

    to {
        width: 100%;
    }
}

@keyframes blink {
    50% {
        border-color: transparent;
    }
}

/* Receipt Ticket Styles (aligné sur le ticket de paiement POS) */
.receipt-ticket {
  background: #fff;
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  color: #333;
  padding: 20px;
  border: solid 1px rgb(220,220,220);
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 350px;
}

.receipt-ticket table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
}

.receipt-ticket td {
  padding: 4px 0;
  vertical-align: top;
  font-size: 13px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
  white-space: nowrap;
}

.company-name {
  font-size: 18px;
  font-weight: 700;
}

.separator {
  color: #999;
  padding: 4px 0 !important;
  text-align: center;
}

.header-line {
  padding: 2px 0 !important;
  font-size: 12px;
}

.separator-light {
  border-bottom: 1px solid #eee;
  padding: 4px 0 !important;
}

.receipt-products-table .product-row td {
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.product-name-cell {
  width: 60%;
}

.product-price-cell {
  width: 40%;
  text-align: right;
  white-space: nowrap;
}

.discount-text {
  font-size: 11px;
  color: #0b3d87;
  font-style: italic;
}

.receipt-totals-table td {
  padding: 5px 0;
}

.payment-row td {
  color: #0b3d87;
}

.total-final-row td {
  font-size: 16px;
  padding-top: 8px !important;
}

.remaining-row td {
  color: #e74c3c;
  font-weight: 600;
}

.qr-section {
  margin-top: 16px;
  padding: 12px;
  background: #f8f9fa;
  border: 2px solid #333;
  border-radius: 8px;
}

.qr-table {
  margin-bottom: 12px;
}

.qr-table td {
  font-size: 11px;
  padding: 2px 0;
}

.qr-code {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.receipt-footer {
  text-align: center;
  margin-top: 16px;
}

.receipt-footer .separator {
  margin: 0;
}

.thanks-text {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 8px 0 0 0;
}
</style>
